var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAssistantIcon5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5285 10.1437L11.9991 21.6731L0.469727 10.1437L11.9991 5.46484L23.5285 10.1437Z",
    fill: "#FD7DA0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 5.48415L8.82261 2.30664H3.77941L0.470703 5.6153V10.1629L12.0001 5.48415Z",
    fill: "#FDCB50"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6523 10.2648V5.77115L20.0862 2.20508H15.407L12.1913 5.42075L23.6523 10.2648Z",
    fill: "#FDCB50"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2208 2.30633L17.9218 7.95226L12.1913 5.51809L15.5075 2.25L20.2208 2.30633Z",
    fill: "#FD8F01"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.77941 2.30664L6.08774 7.92137L0.470703 10.1629V5.6153L3.77941 2.30664Z",
    fill: "#FD8F01"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0.470703 10.1632L11.9991 5.71094V21.4266L0.470703 10.1632Z",
    fill: "#DB4B86"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0.470581 10.1632L12 5.48438",
    stroke: "#052A75",
    strokeWidth: 0.941176,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5294 10.1632L12 5.48438",
    stroke: "#052A75",
    strokeWidth: 0.941176,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 5.48415L15.1776 2.30664H20.2208L23.5295 5.6153V10.1629L12.0001 21.6924L0.470703 10.1629V5.6153L3.77941 2.30664H8.82261L12.0001 5.48415ZM12.0001 5.48415V21.6924",
    stroke: "#052A75",
    strokeWidth: 0.941176,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssistantIcon5);
export default __webpack_public_path__ + "static/media/assistant-icon-5.378bc242a6efffb76e4b24384a0bc860.svg";
export { ForwardRef as ReactComponent };